import React from 'react';
import FilaTablaPartidos from './FilaTablaPartidos';

const TablaPartidos = props => {
  const getPartidos = (camaraSeleccionada, soloConCargo) => {
    let partidos = [];
    partidos = camaraSeleccionada.partotabla;
    if (soloConCargo) {
      partidos = partidos && partidos.filter(x => x.act.carg > 0);
    }
    return partidos;
  };
  const parto = getPartidos(
    props.camaraSeleccionada,
    props.soloConCargo
  );
  return (
    <div>
      {parto && parto.length > 0 && parto.map(partido => {
        return (
          <FilaTablaPartidos
            mostrarVotos={props.mostrarVotos}
            partido={partido}
            soloConCargo={props.soloConCargo}
            mostrarCargos={props.mostrarCargos}
            mostrarCandidatos={props.mostrarCandidatos}
            configConsultas={props.configConsultas}
          />
        );
      })
      }
      { parto === undefined || parto.length === 0 && <div>No hay datos</div>}
    </div>
  );
};

export default TablaPartidos;
